import { claimConstants } from '../constants'
import claimSteps from '../../../shared/claimSteps.json'
import SurveyResponseFormatterUtil from '../../utilities/surveyResponseFormatter'

const initialState = {
  couponClaimLoading: false,
  tokenClaimLoading: false,
  couponCode: null,
  tokenCode: null,
  currentPromotion: null,
  activePromotionStepId: null,
  // claimStep: claimSteps.SELECT_REWARD,
  // claimStep: claimSteps.VERIFY_PURCHASE,
  claimStep: claimSteps.CLAIM_COUPON,
  // claimStep: claimSteps.REWARD_SUMMARY,
  couponClaimError: null,
  tokenClaimError: null,
  selectedContentList: [],
  selectContentError: false,
  confirm: false,
  error: false,
  proofOfPurchase: false,
  survey: null,
  isSurveyCompleted: false,
  surveyId: 0,
  previousButton: false,
}

const addSelectedContent = (state, promotionStepId, content) => {
  // Find or create promotion step
  const contentList = JSON.parse(JSON.stringify(state.selectedContentList))
  let promotionStep = contentList.find(step => step.promotionStepId === promotionStepId)
  const stepExists = !!promotionStep
  promotionStep = promotionStep || {
    promotionStepId,
    selectedContent: [],
  }
  const activePromotionStep = state.currentPromotion.promotionSteps.find(
    step => step.id === promotionStepId
  )
  let cost = activePromotionStep.currentCreditsUsed
  const { maximumSelections, creditsUsed } = activePromotionStep
  const { currentCreditsUsed } = activePromotionStep
  if (maximumSelections - creditsUsed - currentCreditsUsed - content.credits < 0) {
    throw new Error({ message: 'Not enough credits to redeem' })
  }
  // Add promotion step
  if (!promotionStep.selectedContent.find(temp => content.contentId === temp.contentId)) {
    promotionStep.selectedContent.push(content)
    promotionStep.selectedContent.sort()
    cost += content.credits
  }
  if (!stepExists) {
    contentList.push(promotionStep)
  }

  const updatedPromotionSteps = state.currentPromotion.promotionSteps.map(step => {
    if (step.id === activePromotionStep.id) {
      return { ...step, currentCreditsUsed: cost }
    }
    return { ...step }
  })

  return {
    ...state,
    selectedContentList: contentList,
    currentPromotion: {
      ...state.currentPromotion,
      promotionSteps: updatedPromotionSteps,
    },
  }
}

const removeSelectedContent = (state, promotionStepId, content) => {
  const contentList = JSON.parse(JSON.stringify(state.selectedContentList))
  const promotionStep = contentList.find(
    contentStep => contentStep.promotionStepId === promotionStepId
  )
  const stepExists = !!promotionStep
  const index =
    stepExists &&
    promotionStep.selectedContent.map(temp => temp.contentId).indexOf(content.contentId)

  const activePromotionStep = state.currentPromotion.promotionSteps.find(
    step => step.id === promotionStepId
  )
  let cost = activePromotionStep.currentCreditsUsed

  if (stepExists && index > -1) {
    promotionStep.selectedContent.splice(index, 1)
    cost -= content.credits
  }

  const updatedPromotionSteps = state.currentPromotion.promotionSteps.map(step => {
    if (step.id === activePromotionStep.id) {
      return { ...step, currentCreditsUsed: cost }
    }
    return { ...step }
  })

  return {
    ...state,
    selectedContentList: contentList,
    currentPromotion: {
      ...state.currentPromotion,
      promotionSteps: updatedPromotionSteps,
    },
  }
}

// Could potentially break if all promotionsteps are filtered or all promotionstepcontent is filtered and nothing is returned.
const filterPromotionSteps = currentPromotion => {
  const promotionSteps = currentPromotion.promotionSteps.slice(0)
  promotionSteps.sort((a, b) => a.sortOrder > b.sortOrder)
  const filteredPromoSteps = promotionSteps.filter(
    step => !(step.maximumSelections - step.creditsUsed <= 0)
  ) // TODO: Negation of logic unnecessary
  return filteredPromoSteps.map(promotionStep => {
    const redeemedContent = new Set(promotionStep.redeemedContent.map(content => content.contentId)) // TODO: FIXME: This may break IE11??
    const filteredContent = promotionStep.promotionStepContent.filter(
      stepContent => !redeemedContent.has(stepContent.contentId)
    )
    return { ...promotionStep, promotionStepContent: filteredContent }
  })
}

const updateCurrentlyUsedCredits = (state, currentPromotion) => {
  const promotionSteps = currentPromotion.promotionSteps.slice(0)
  if (state.selectedContentList.length) {
    return promotionSteps.map(promotion => {
      const selected = state.selectedContentList.find(x => x.promotionStepId === promotion.id)
      if (selected) {
        let currentCreditsUsed = 0
        selected.selectedContent.forEach(content => {
          currentCreditsUsed += content.credits
        })
        return { ...promotion, currentCreditsUsed }
      }
      return promotion
    })
  }
  return promotionSteps
}

const formatRedemptions = (state, redemptions) => {
  let selectedContentList = state.selectedContentList.slice(0)
  selectedContentList = selectedContentList.map(promotionStep => ({
    ...promotionStep,
    selectedContent: [],
  }))
  redemptions.forEach(redemption => {
    const promotionStep = selectedContentList.find(
      x => x.promotionStepId === redemption.promotionStepId
    )
    promotionStep.selectedContent.push(redemption)
  })
  return selectedContentList
}

const claimReducer = (state = initialState, action) => {
  let contentId
  let content
  let promotionStepId
  let promotion
  let errorMessage

  switch (action.type) {
    // Coupon Claim
    case claimConstants.CLAIM_COUPON_REQUEST:
      return {
        ...state,
        couponClaimLoading: true,
        couponCode: action.body.couponCode,
        couponClaimError: null,
      }
    case claimConstants.CLAIM_COUPON_SUCCESS:
      return { ...state, couponClaimLoading: false, claimStep: action.response.claimStep }
    case claimConstants.CLAIM_COUPON_PROOF_REQUIRED:
      return { ...state, couponClaimLoading: false, proofOfPurchase: action.body.proofOfPurchase }
    case claimConstants.CLAIM_COUPON_FAILURE:
      if (action.error.errors && action.error.errors.length) {
        errorMessage = action.error.errors[0].message
      } else if (action.error.errors && action.error.errors.message) {
        errorMessage = action.error.errors.message
      } else if (action.error && action.error.message === 'error.coupon.couponNotValid') {
        // Validation error - maxLength and minLength
        errorMessage = action.error.message
      } else {
        errorMessage = '500' // TODO: GENERIC ERROR NEEDED FOR COUPON FAILURE
      }
      return { ...state, couponClaimLoading: false, couponClaimError: errorMessage }

    // Token Claim
    case claimConstants.CLAIM_TOKEN_REQUEST:
      return {
        ...state,
        couponClaimLoading: true,
        tokenCode: action.body.tokenCode,
        couponClaimError: null,
      }
    case claimConstants.CLAIM_TOKEN_SUCCESS:
      return {
        ...state,
        couponClaimLoading: false,
        claimStep: action.response.claimStep,
        couponCode: action.response.couponCode,
      }
    case claimConstants.CLAIM_TOKEN_PROOF_REQUIRED:
      return { ...state, couponClaimLoading: false, proofOfPurchase: action.body.proofOfPurchase }
    case claimConstants.CLAIM_TOKEN_FAILURE:
      if (action.error.errors && action.error.errors.length) {
        errorMessage = action.error.errors[0].message
      } else if (action.error.errors && action.error.errors.message) {
        errorMessage = action.error.errors.message
      } else if (action.error && action.error.message === 'error.coupon.couponNotValid') {
        // Validation token error - maxLength min minLength
        errorMessage = action.error.message
      } else {
        errorMessage = '500' // TODO: GENERIC ERROR NEEDED FOR TOKEN FAILURE
      }
      return { ...state, couponClaimLoading: false, couponClaimError: errorMessage }

    // Modify Selected Content
    case claimConstants.ADD_SELECTED_CONTENT:
      content = action.body.content
      promotionStepId = action.body.promotionStepId
      return addSelectedContent(state, promotionStepId, content)
    case claimConstants.ADD_SELECTED_CONTENT_FAILURE:
      return { ...state, selectContentError: true }
    case claimConstants.REMOVE_SELECTED_CONTENT:
      contentId = action.body.contentId
      promotionStepId = action.body.promotionStepId
      return removeSelectedContent(state, promotionStepId, contentId)

    // Get promotion
    case claimConstants.GET_PROMOTION_SUCCESS:
      promotion = { ...action.response.promotion }
      promotion.promotionSteps.sort((a, b) => a.sortOrder > b.sortOrder)
      promotion.promotionSteps = filterPromotionSteps(promotion)
      promotion.promotionSteps = updateCurrentlyUsedCredits(state, promotion)
      return { ...state, currentPromotion: promotion }
    case claimConstants.GET_PROMOTION_FAILURE:
      return { ...state, error: true }

    // Set active promotion step
    case claimConstants.SET_ACTIVE_PROMOTION_STEP:
      return { ...state, activePromotionStepId: action.body.promotionStepId }

    // Set Claim State
    case claimConstants.PREVIOUS_CLAIM_STATE:
      return { ...state, claimStep: state.claimStep - 1 }
    case claimConstants.NEXT_CLAIM_STATE:
      return { ...state, claimStep: state.claimStep + 1 }
    case claimConstants.CLAIM_SUCCESS:
      return { ...state, selectedContentList: formatRedemptions(state, action.body.redemptions) }
    // COMMENTED OUT UNTIL REDEMPTION KEY ASSIGNMENT BUG IS SOLVED
    // return { ...state, selectedContentList: formatRedemptions(state, action.body.redemptions), redemptionId: action.body.redemptionId }
    case claimConstants.CLAIM_FAILURE:
      return { ...state, error: true, claimStep: claimSteps.ERROR }
    case claimConstants.SET_SELECT_STATE: {
      const { coupon } = action.body
      // if survey is `skip survey` then we go directly to select reward
      // if survey is `normal survey` and survey is completed, then we go to select reward
      if (state.surveyId === 0 || (state.surveyId !== 0 && state.isSurveyCompleted)) {
        return { ...state, couponCode: coupon, claimStep: claimSteps.SELECT_REWARD }
      }

      // if survey is not `skip survey` and user has not completed survey
      if (state.surveyId !== 0 && !state.isSurveyCompleted) {
        return { ...state, couponCode: coupon, claimStep: claimSteps.ATTEMPT_SURVEY }
      }
      return { ...state, couponCode: coupon, claimStep: claimSteps.SELECT_REWARD }
    }

    case claimConstants.CLEAR_REDEEM_STATE:
      return {
        ...state,
        claimStep: claimSteps.CLAIM_COUPON,
        couponCode: null,
        tokenCode: null,
        couponClaimLoading: false,
        tokenClaimLoading: false,
        activePromotionStepId: null,
        currentPromotion: null,
        selectedContentList: [],
        selectContentError: false,
        error: false,
        proofOfPurchase: false,
        couponClaimError: null,
        tokenClaimError: null,
      }
    // Toggle Confirmation
    case claimConstants.TOGGLE_CONFIRM:
      return {
        ...state,
        confirm: !state.confirm,
      }

    case claimConstants.CLEAR_PROOF_OF_PURCHASE:
      return {
        ...state,
        proofOfPurchase: false,
      }

    case claimConstants.GET_SURVEY_SUCCESS: {
      const { survey_questions: surveyQuestions, id: surveyId } = action.response.survey
      const survey = SurveyResponseFormatterUtil.getFlattenResponse(surveyQuestions)

      return {
        ...state,
        survey,
        previousButton: false,
        surveyId,
        claimStep: surveyId === 0 ? claimSteps.SELECT_REWARD : claimSteps.ATTEMPT_SURVEY,
      }
    }

    case claimConstants.GET_SURVEY_FAILURE: {
      return {
        ...state,
        previousButton: true,
        claimStep: claimSteps.SELECT_REWARD,
      }
    }

    case claimConstants.UPDATE_SURVEY_FIELD_DATA_SUCCESS: {
      const { response, question } = action.body
      const { survey } = state
      const index = survey.findIndex(element => element.question === question)

      return {
        ...state,
        survey: [
          ...state.survey.slice(0, index),
          {
            ...state.survey[index],
            response,
          },
          ...state.survey.slice(index + 1),
        ],
      }
    }

    case claimConstants.UPDATE_SURVEY_FIELD_RESPONSE: {
      const { response, question } = action.body
      const { survey } = state
      const index = survey.findIndex(element => element.question === question)

      return {
        ...state,
        survey: [
          ...state.survey.slice(0, index),
          {
            ...state.survey[index],
            finalResponse: response,
          },
          ...state.survey.slice(index + 1),
        ],
      }
    }

    case claimConstants.CHECK_SURVEY_COMPLETE_SUCCESS: {
      const { isSurveyCompleted, surveyId } = action.body
      return {
        ...state,
        isSurveyCompleted,
        surveyId,
      }
    }

    // Default
    default:
      return state
  }
}

export default claimReducer
